export const QuestionBank = [
    {
        q: "Are you shopping sustainably and locally on our high streets?",
    },
    {
        q:"Have you joyfully joined in with the festive spirit and been to a local light switch on?",
    },
    {
        q: "Have you experienced one of our many seasonal attractions; from riding The POLAR EXPRESS™ on Seaton Tramwa to sailing with Santa on Stuart Line Cruises, walking the Connaught Illuminated Garden Walk or taking to the Festive Glow Trail at The Donkey Sanctuary?",
    },
    {
        q: "Are you planning a festive lunch or seasonal supper at one of East Devon’s amazing cafés or restaurants?"
    },
    {
        q: "Will you be swapping the usual online gift buys for something a little more unusual, such as replacing mince pies for locally produced scones with rich clotted cream (cream first, obviously); traditional brandy for a locally made mellow glass of beer or glass of white wine from the local vineyards; a pair of socks for a hand-crafted gift made locally?"
    },

]